import { removeParam } from './url';
class MemoryManager {
    static getStorage(level) {
        switch(level) {
            case 'local':
                return localStorage;
            case 'session':
                return sessionStorage;
            case 'native':
                return '';
            default:
                return sessionStorage;
        }
    }

    static updateMemoryMap(key,level, isDelete) {
        const storage = this.getStorage('local');
        let storeMap = this.getStoreMap('rememberPosition');
        const idx = storeMap.findIndex(item => {
            return item.key === key;
        });

        if(isDelete && idx != -1) {
            storeMap = [...storeMap.slice(0,idx),...storeMap.slice(idx + 1)];
        }else {
            if(idx === -1) {
                storeMap.push({ key,level });
            }else {
                storeMap[idx] = { key,level };
            }
        }

        storage.setItem('rememberPosition',JSON.stringify(storeMap));
    }


    static setItem(key, item, level = 'session') {
        const storage = this.getStorage(level);
        storage.setItem(key,JSON.stringify(item));
        this.updateMemoryMap(key,level);
    }

    static setItemBeforeUnload(key, fn, level = 'session') {
        if(key.indexOf('_k=') !== -1) {
            key = removeParam('_k',key);
        }

        window._events = window._events || {
            'beforeUnload': []
        };

        const idx = window._events['beforeUnload'].findIndex(item => {
            return item.key === key;
        });

        const beforeUnloadCallback = function(key,direction) {
            const storage = this.getStorage(level);
            if(direction === 'forward') {
                storage.setItem(key, JSON.stringify(fn()));
                this.updateMemoryMap(key,level);
            }else {
                this.removeItem(key);
            }
        };

        const obj = { key: key, callback: beforeUnloadCallback.bind(this) };
        if(idx == -1) {
            window._events['beforeUnload'].push(obj);
        }else {
             window._events['beforeUnload'][idx] = obj;
        }
    }
 
    static removeItem(key) {
        if(key.indexOf('_k=') !== -1) {
            key = removeParam('_k',key);
        }
         localStorage.removeItem(key);
         sessionStorage.removeItem(key);
         this.updateMemoryMap(key,'',true);
    }

    static getItem(key) {
        key = removeParam('_k',key);
        const storeMap = JSON.parse(this.getStorage('local').getItem('rememberPosition'));
        const item = storeMap && storeMap.find(item => item.key === key);
        if(item) {
            return this.getStorage(item.level).getItem(item.key);
        }
        return null;
    }

    static getStoreMap(item) {
        const storage = this.getStorage('local');
        return JSON.parse(storage.getItem(item)) || [];
    }

    static clear(namespace) {
        const storeMap = this.getStoreMap(namespace);
        storeMap.forEach(item => {
            this.getStorage(item.level).removeItem(item.key);
        });
    }
}
export default MemoryManager;



// WEBPACK FOOTER //
// ./src/components/util/memoryManager.js